import { render, staticRenderFns } from "./ReviewsTags.vue?vue&type=template&id=ae319c82&"
import script from "./ReviewsTags.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ReviewsTags.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ReviewsTags.vue?vue&type=style&index=0&id=ae319c82&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae319c82')) {
      api.createRecord('ae319c82', component.options)
    } else {
      api.reload('ae319c82', component.options)
    }
    module.hot.accept("./ReviewsTags.vue?vue&type=template&id=ae319c82&", function () {
      api.rerender('ae319c82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/ReviewsTags/ReviewsTags.vue"
export default component.exports